module.exports = __webpack_public_path__ + "static/media/user-profile.143eee92.svg";